import ParamExplorationCol from '@/views/parametres/configs/param-sagefemme/param-exploration-col'
import ParamEtatSeins from '@/views/parametres/configs/param-sagefemme/param-etat-seins'
import ParamAnnexe from '@/views/parametres/configs/param-sagefemme/param-annexe'

import store_config from '@/store/mods/parametres/config'

export default {
    name: 'param-sagefemme',
    components: {
        ParamExplorationCol, ParamEtatSeins, ParamAnnexe
    },
    props: [],
    data() {
        return {
            config_to_show: '1',
            params_cpn: {},
            is_loading: true,
        }
    },

    computed: {

    },

    mounted() {
        this.getListeParamCPN()
    },

    methods: {
        changeTab(tabindex) {
            this.config_to_show = tabindex
        },

        getListeParamCPN() {
            this.is_loading = true
            store_config.getAllParamCpn().then((response) => {
                this.params_cpn = response

                this.is_loading = false
            })      
        }
    }
}